import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

const BASE_URL = environment.BASE_URL

@Injectable({
  providedIn: 'root',
})
export class KeyMetricsService {
  private http = inject(HttpClient);

  getMetrics(): Observable<any> {
    const url = `${BASE_URL}keymetric/get-metrics`;
    const res = this.http.get(url);
    return res;
  }

}
